/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostReleasePoliciesOrderPathParams = NonNullable<
  operations['PostReleasePoliciesOrder']['parameters']['path']
>;

export type PostReleasePoliciesOrderRequestBody = OperationRequestBodyContent<operations['PostReleasePoliciesOrder']>;

export interface Input extends PostReleasePoliciesOrderPathParams {
  apiVersion?: string;
  body: PostReleasePoliciesOrderRequestBody;
  header: NonNullable<operations['PostReleasePoliciesOrder']['parameters']['header']>;
}

export async function PostReleasePoliciesOrder(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/release-policies/order', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
